import { computed, type ComputedRef } from 'vue'
import { storeToRefs } from 'pinia'
import { openAssistantChat, toggleAssistantChat } from '@cplug/assistant-chat'
import { useAuthenticationStore } from '@cplug/frontend-shared-domains/domain/authentication'
import useFeatureFlagStore from '~/domain/shared/feature-flag/stores/useFeatureFlagStore'

interface UseAssistantChatReturn {
  isAssistantEnabled: ComputedRef<boolean>
  showAssistantComingSoon: ComputedRef<boolean>
  openAssistantChat: typeof openAssistantChat
  toggleAssistantChat: typeof toggleAssistantChat
}

export function useAssistantChat (): UseAssistantChatReturn {
  const featureFlagStore = useFeatureFlagStore()
  const authStore = useAuthenticationStore()
  const { logged, companies } = storeToRefs(authStore)

  const hasSessionCompany = computed(() =>
    logged.value && !!companies.value?.[0]?.id
  )

  const isAssistantFlagEnabled = computed(() =>
    featureFlagStore.isEnabled('cplug_assistant')
  )

  const isAssistantEnabled = computed(() =>
    isAssistantFlagEnabled.value && hasSessionCompany.value
  )

  const showAssistantComingSoon = computed(() =>
    featureFlagStore.fetched &&
    !isAssistantFlagEnabled.value &&
    hasSessionCompany.value
  )

  return {
    isAssistantEnabled,
    showAssistantComingSoon,
    openAssistantChat,
    toggleAssistantChat
  }
}
